import {NgModule} from '@angular/core';
import {BRANDS_COMPONENTS, BRANDS_SERVICES} from '.';
import {CommonModule} from '@angular/common';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [...BRANDS_COMPONENTS],
  exports: [...BRANDS_COMPONENTS],
  providers: [...BRANDS_SERVICES]
})

export class BrandsModule {
}
